<template>
  <section class="trust-strip" aria-label="Rating, licenses and certifications">
    <a class="rating" :href="reviewsUrl" target="_blank" rel="noopener">
      <span class="stars" aria-hidden="true">★★★★★</span>
      <span><b>5.0</b> on Google</span>
      <span class="rating-link">Read reviews</span>
    </a>
    <ul class="badges">
      <li v-for="badge in badges" :key="badge.name">
        <img :src="badge.image" :alt="badge.name" width="120" height="90" loading="lazy" decoding="async" />
      </li>
    </ul>
    <ul class="facts">
      <li>Michigan licensed #252400025</li>
      <li>$1M liability insured</li>
      <li>50-year warranty available</li>
      <li>Financing on projects over $3,000</li>
    </ul>
  </section>
</template>

<script>
// Short proof row right under the hero: the certifications homeowners
// recognize, next to the call-to-action instead of halfway down the page.
import { reviewLinks } from '@/seo/reviews';

export default {
  name: 'TrustStrip',
  props: {
    // Which Google listing the rating links to: 'niles' or 'gaylord'
    location: { type: String, default: 'niles' }
  },
  computed: {
    reviewsUrl() {
      return (reviewLinks[this.location] || reviewLinks.niles).listing;
    }
  },
  data() {
    return {
      badges: [
        { name: 'CertainTeed Shingle Master', image: require('@/assets/optimized/badges/ShingleMaster-400.webp') },
        { name: 'CertainTeed Master Craftsman', image: require('@/assets/optimized/badges/MasterCraftsman-400.webp') },
        { name: 'TAMKO Pro Platinum', image: require('@/assets/optimized/badges/TAMKO-Pro-Platinum-400.webp') },
        { name: 'EPA Lead-Safe Certified Firm', image: require('@/assets/optimized/badges/lead-safe-certified-firm-400.webp') }
      ]
    };
  }
};
</script>

<style scoped>
.trust-strip {
  background: rgba(0, 20, 45, 0.55);
  border-top: 1px solid rgba(241, 196, 15, 0.35);
  border-bottom: 1px solid rgba(241, 196, 15, 0.35);
  padding: 18px 20px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 18px 36px;
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}

.rating {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px;
  border-radius: 10px;
  background: #fff;
  color: #1a1a1a;
  text-decoration: none;
  font-size: 1rem;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s ease;
}

.rating:hover {
  transform: translateY(-2px);
}

.rating:focus-visible {
  outline: 3px solid #f1c40f;
  outline-offset: 3px;
}

.stars {
  color: #e7a90b;
  font-size: 1.15rem;
  letter-spacing: 1px;
}

.rating b {
  font-size: 1.1rem;
}

.rating-link {
  color: #1a56a8;
  font-weight: 600;
  font-size: 0.9rem;
  text-decoration: underline;
}

.badges {
  gap: 16px;
}

.badges img {
  display: block;
  height: 58px;
  width: auto;
  object-fit: contain;
}

.facts {
  gap: 10px;
}

.facts li {
  padding: 8px 14px;
  border-radius: 999px;
  border: 1px solid rgba(241, 196, 15, 0.45);
  background: rgba(255, 255, 255, 0.06);
  color: #f5f5f5;
  font-size: 0.92rem;
  font-weight: 600;
  white-space: nowrap;
}

.facts li::before {
  content: '\2713';
  color: #f1c40f;
  font-weight: 900;
  margin-right: 7px;
}

@media (max-width: 600px) {
  .trust-strip {
    padding: 16px 12px;
    gap: 14px;
  }

  .badges {
    gap: 10px;
  }

  .badges img {
    height: 46px;
  }

  .facts {
    gap: 8px;
  }

  .facts li {
    font-size: 0.84rem;
    padding: 7px 11px;
    white-space: normal;
  }
}
</style>
